var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotelIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hoteles",
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 66,
    viewBox: "0 0 90 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_47",
    "data-name": "Trazado 47",
    d: "M30.162,0V6.789h-7.91V66H36.909V45.088H52.493V66H67.266V6.789H59.24V0Z",
    fill: "#20221d"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3",
    "data-name": "Rect\\xE1ngulo 3",
    width: 6.399,
    height: 6.555,
    transform: "translate(47.957 6.528)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4",
    "data-name": "Rect\\xE1ngulo 4",
    width: 6.399,
    height: 6.438,
    transform: "translate(35.047 32.274)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_5",
    "data-name": "Rect\\xE1ngulo 5",
    width: 6.399,
    height: 6.322,
    transform: "translate(35.047 19.518)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6",
    "data-name": "Rect\\xE1ngulo 6",
    width: 6.399,
    height: 6.555,
    transform: "translate(35.047 6.528)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7",
    "data-name": "Rect\\xE1ngulo 7",
    width: 6.399,
    height: 6.438,
    transform: "translate(47.957 32.274)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_8",
    "data-name": "Rect\\xE1ngulo 8",
    width: 6.399,
    height: 6.322,
    transform: "translate(47.957 19.518)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9",
    "data-name": "Rect\\xE1ngulo 9",
    width: 19.469,
    height: 38.277,
    transform: "translate(0 27.723)",
    fill: "#fdb54e"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10",
    "data-name": "Rect\\xE1ngulo 10",
    width: 6.399,
    height: 6.555,
    transform: "translate(6.535 32.215)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_11",
    "data-name": "Rect\\xE1ngulo 11",
    width: 6.399,
    height: 6.555,
    transform: "translate(25.071 32.215)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_12",
    "data-name": "Rect\\xE1ngulo 12",
    width: 6.399,
    height: 6.555,
    transform: "translate(6.535 45.088)",
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_13",
    "data-name": "Rect\\xE1ngulo 13",
    width: 6.399,
    height: 6.555,
    transform: "translate(25.071 45.088)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_14",
    "data-name": "Rect\\xE1ngulo 14",
    width: 19.469,
    height: 38.277,
    transform: "translate(70.531 27.723)",
    fill: "#fdb54e"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 6.399,
    height: 6.555,
    transform: "translate(58.556 32.215)",
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_16",
    "data-name": "Rect\\xE1ngulo 16",
    width: 6.399,
    height: 6.555,
    transform: "translate(77.066 32.215)",
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17",
    "data-name": "Rect\\xE1ngulo 17",
    width: 6.399,
    height: 6.555,
    transform: "translate(58.556 45.088)",
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_18",
    "data-name": "Rect\\xE1ngulo 18",
    width: 6.399,
    height: 6.555,
    transform: "translate(77.066 45.088)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelIcon2);
export default __webpack_public_path__ + "static/media/hotelIcon2.ecd63046969ffeec8e21388d1e6031fe.svg";
export { ForwardRef as ReactComponent };